import React, { useCallback, useRef, useState } from "react";
import { Button, MenuItem } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Dropdown from "../controls/Dropdown";
import Icon from "../controls/Icon";
import PortalMenu from "../controls/PortalMenu";
import Spinner from "../controls/Spinner";
import { IconButton } from "../controls/TooltipControls";
const Action = (props) => {
    const { count, icon, title, onTrigger } = props;
    const { t } = useTranslation(["common"]);
    const trigger = useCallback(() => {
        onTrigger(title);
    }, [onTrigger, title]);
    if (icon !== undefined) {
        return (React.createElement(IconButton, { icon: icon, tooltip: t(title, { count }), onClick: trigger }));
    }
    else {
        return React.createElement(Button, { onClick: trigger }, t(title, { count }));
    }
};
const typeToStyle = (type) => {
    switch (type) {
        case "success":
            return "success";
        case "activity":
            return "info";
        case "info":
            return "info";
        case "warning":
            return "warning";
        case "error":
            return "danger";
        default:
            return "warning";
    }
};
const typeToIcon = (type) => {
    switch (type) {
        case "activity":
            return React.createElement(Spinner, null);
        case "success":
            return React.createElement(Icon, { name: "feedback-success" });
        case "info":
            return React.createElement(Icon, { name: "feedback-info" });
        case "warning":
            return React.createElement(Icon, { name: "feedback-warning" });
        case "error":
            return React.createElement(Icon, { name: "feedback-error" });
        default:
            return null;
    }
};
export const Notification = (props) => {
    const { collapsed, onDismiss, onExpand, onSuppress, onTriggerAction, params, } = props;
    const { actions, id, message, noDismiss, progress, title, type } = params;
    const { t } = useTranslation(["common"]);
    const [open, setOpen] = useState(false);
    const menuRef = useRef(null);
    const handleOpen = useCallback(() => {
        setOpen(true);
    }, []);
    const handleClose = useCallback(() => {
        setOpen(false);
    }, []);
    const suppressNotification = useCallback(() => {
        onSuppress?.(params.id);
    }, [onSuppress, params.id]);
    const trigger = useCallback((actionTitle) => {
        onTriggerAction?.(params.id, actionTitle);
    }, [onTriggerAction, params.id]);
    const expand = useCallback(() => {
        onExpand?.(params.group);
    }, [onExpand, params.group]);
    const dismiss = useCallback(() => {
        onDismiss?.(params.id);
    }, [onDismiss, params.id]);
    const renderAction = (action) => {
        return (React.createElement(Action, { count: collapsed, icon: action.icon, key: action.title ?? action.icon, title: action.title, onTrigger: trigger }));
    };
    const renderExtraOptions = () => {
        // currently that's the only extra option
        const hasExtraOptions = params.allowSuppress === true;
        if (!hasExtraOptions) {
            return null;
        }
        return (React.createElement(Dropdown, { className: "notification-extra-options", id: `notification-${params.id}-extra`, ref: menuRef },
            React.createElement(Dropdown.Toggle, { onClick: handleOpen },
                React.createElement(Icon, { name: "settings" })),
            React.createElement(PortalMenu, { bsRole: "menu", open: open, target: menuRef.current, onClick: handleClose, onClose: handleClose }, params.allowSuppress && onSuppress !== undefined ? (React.createElement(MenuItem, { eventKey: "suppress", onClick: suppressNotification }, t("Never show again"))) : null)));
    };
    if (message === undefined && title === undefined) {
        return null;
    }
    const lines = (message || "")
        // improve chance the message can be line-broken on hover
        .replace(/\W/g, (_) => `${_}\u200b`)
        .split("\n");
    const styleName = typeToStyle(type);
    return (React.createElement("div", { className: `
        notification
        alert-${styleName}
      `, role: "alert" },
        progress !== undefined ? (React.createElement("span", { className: "notification-progress", style: { left: `${progress}%` } })) : null,
        React.createElement("div", { className: "btn btn-default btn-embed no-hover" },
            typeToIcon(type),
            " "),
        React.createElement("div", { className: "notification-textbox" },
            title !== undefined ? (React.createElement("div", { className: "notification-title" }, title)) : null,
            React.createElement("div", { className: "notification-message hover-expand" }, lines.map((line) => (React.createElement("span", { key: line }, line))))),
        React.createElement("div", { className: "notification-buttons" },
            actions !== undefined && onTriggerAction !== undefined
                ? actions.map((action) => renderAction(action))
                : null,
            !noDismiss && onDismiss !== undefined ? (React.createElement(IconButton, { icon: "close", tooltip: collapsed > 1 ? t("Dismiss All") : t("Dismiss"), onClick: dismiss })) : null,
            collapsed > 1 && onExpand !== undefined ? (React.createElement(Button, { onClick: expand }, t("{{ count }} More", { count: collapsed - 1 }))) : null,
            id !== undefined ? renderExtraOptions() : null)));
};
export default Notification;
